import React from 'react';
import { CgiProvider } from '../../interfaces/CGI';

interface Props {
  provider: CgiProvider;
  size: 'medium';
}

export const CgiProviderLogo: React.FC<Props> = ({ size, provider }) => {
  const baseClass = 'membership-app__providerLogo';
  let classNames = [`${baseClass}`, `${baseClass}--${size}`];
  const classes = classNames.join(' ');
  return (
    <>
      {provider === CgiProvider.Freja ? (
        <svg
          className={classes}
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          xmlSpace="preserve"
        >
          <style
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                '\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Oval_00000054984994581999933250000013152839010308989085_);}\n\t.st1{fill:#FDFDFD;}\n',
            }}
          />
          <linearGradient
            id="Oval_00000055691134256345537340000018117792005006981539_"
            gradientUnits="userSpaceOnUse"
            x1="-443.2742"
            y1="545.2752"
            x2="-444.5103"
            y2="546.5096"
            gradientTransform="matrix(100 0 0 -100 44451 54651)"
          >
            <stop offset={0} style={{ stopColor: '#0A98E7' }} />
            <stop offset={1} style={{ stopColor: '#3E3A94' }} />
          </linearGradient>
          <circle
            id="Oval"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: 'url(#Oval_00000055691134256345537340000018117792005006981539_)',
            }}
            cx={50}
            cy={50}
            r={50}
          />
          <path
            id="Path"
            className="st1"
            d="M72.7,31.7l3-8c0.4-0.9-0.2-1.7-1.1-1.7H38.3c-0.5,0-0.9,0.3-1.1,0.8l-4.1,10.1c0,0-0.1,0.2-0.1,0.4
v43.6c0,1.3,0.6,1.9,1.2,1.9h9.6c0.7,0,1.2-0.6,1.2-1.2V57c0-0.7,0.6-1.2,1.2-1.2h16c0.5,0,1-0.3,1.2-0.8l3.2-7.9
c0.3-0.8-0.2-1.7-1.2-1.7H46.3c-0.7,0-1.2-0.6-1.2-1.2V33.7c0-0.7,0.6-1.2,1.2-1.2h25.2C72,32.4,72.5,32.1,72.7,31.7z"
          />
        </svg>
      ) : provider === CgiProvider.BankId ? (
        <svg
          className={classes}
          viewBox="0 0 83 84"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="41.5" cy="42" r="41.5" fill="#fff" />
          <path
            d="M34.55 42.428 36 33.144h-1.548c-.724 0-1.658-.413-1.932-1.172-.088-.256-.296-1.138.9-1.997.428-.301.703-.636.758-.893.055-.267-.011-.502-.198-.68-.263-.257-.78-.402-1.438-.402-1.109 0-1.888.647-1.965 1.116-.055.346.208.625.439.803.692.525.856 1.283.428 1.998-.439.736-1.394 1.216-2.415 1.227h-1.58C27.315 34.048 25.164 47.907 25 49h8.574c.077-.491.472-3.113 1.01-6.572h-.033Z"
            fill="#479CBE"
          />
          <path
            d="M47.274 25h-9.065L37 32.513h1.54c.843 0 1.641-.38 1.983-.927a.883.883 0 0 0 .16-.48c0-.313-.217-.547-.433-.703-.593-.436-.719-.893-.719-1.217 0-.067 0-.123.012-.179.125-.792 1.22-1.652 2.668-1.652.867 0 1.528.201 1.927.57.353.323.49.781.388 1.261-.126.57-.707 1.038-1.038 1.273-.878.602-.764 1.127-.707 1.283.183.47.878.77 1.414.77h2.337v.012c3.193.022 4.904 1.462 4.368 4.81-.502 3.115-2.942 4.455-5.85 4.477L43.9 49h1.698c7.172 0 13.033-4.51 14.185-11.632C61.207 28.528 55.483 25 47.274 25Z"
            fill="#00A5C3"
          />
          <path
            d="M47.274 25h-9.065L37 32.513h1.54c.843 0 1.641-.38 1.983-.927a.883.883 0 0 0 .16-.48c0-.313-.217-.547-.433-.703-.593-.436-.719-.893-.719-1.217 0-.067 0-.123.012-.179.125-.792 1.22-1.652 2.668-1.652.867 0 1.528.201 1.927.57.353.323.49.781.388 1.261-.126.57-.707 1.038-1.038 1.273-.878.602-.764 1.127-.707 1.283.183.47.878.77 1.414.77h2.337v.012c3.193.022 4.904 1.462 4.368 4.81-.502 3.115-2.942 4.455-5.85 4.477L43.9 49h1.698c7.172 0 13.033-4.51 14.185-11.632C61.207 28.528 55.483 25 47.274 25Z"
            fill="#235971"
          />
          <g fill="#235971">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.967 53h3.63c1.548 0 1.923.75 1.81 1.435-.092.554-.49.967-1.173 1.239.865.315 1.207.804 1.081 1.576-.159.967-1.035 1.685-2.184 1.685H23L23.967 53Zm2.401 2.456c.706 0 1.036-.358 1.104-.782.068-.457-.148-.772-.853-.772h-.626l-.25 1.554h.625Zm.865 1.707c-.102.576-.523.859-1.252.859v.01h-.66l.273-1.662h.717c.706 0 1.002.293.922.793ZM32.775 58.554c.227.392.682.49 1.627.424l.546-1.217c-.535-.011-.557-.152-.478-.609l.216-1.304c.182-1.152-.796-1.587-1.9-1.587-.865 0-1.616.25-2.39.782l-.216 1.348c.9-.587 1.423-.782 2.048-.782.535 0 .706.152.66.565-.256.166-.692.271-1.148.38-.557.134-1.143.275-1.469.544-.273.228-.444.5-.49.782-.101.587.274 1.12 1.344 1.12.591 0 1.149-.152 1.65-.446Zm-.63-1.39c.223-.063.446-.125.618-.23l-.102.653c-.034.206-.046.315-.023.424-.296.195-.66.315-.956.315-.307 0-.5-.217-.455-.51.067-.415.493-.534.919-.652Z"
            />
            <path d="M36.166 54.337h1.889l-.103.598c.603-.49 1.059-.674 1.65-.674 1.058 0 1.548.62 1.377 1.63l-.49 3.033h-1.888l.41-2.511c.08-.456-.069-.674-.433-.674-.296 0-.569.152-.83.49l-.433 2.684h-1.889l.74-4.576ZM42.447 53h1.889l-.478 2.913 1.81-1.576H48l-2.321 1.956 1.866 2.63h-2.378l-1.434-2.119h-.023l-.341 2.12h-1.89L42.448 53Z" />
          </g>
          <g fill="#479CBE">
            <path d="M49.937 53h2.13l-.937 6H49l.937-6Z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M56.15 53h-3.046l-.948 6h3.436c2.063 0 3.156-1.552 3.368-2.917.223-1.399-.457-3.083-2.81-3.083Zm.702 2.995c-.167 1.067-.736 1.574-1.773 1.574h-.558l.49-3.149h.57c1.148 0 1.394.782 1.271 1.575Z"
            />
          </g>
        </svg>
      ) : null}
    </>
  );
};
